// extracted by mini-css-extract-plugin
export default {"layout":"styles__layout___L6umj","bottomBar":"styles__bottomBar___eiD86"};